





























import { Component, Prop, Mixins } from 'vue-property-decorator';
import { ListOption } from '@/interfaces/registration/ListOption';
import FormFieldMixin from '@/mixins/registration/FormFieldMixin';
import RequiredFieldValidator from './validation/RequiredFieldValidator.vue';

  @Component({
    components: { RequiredFieldValidator }
  })
export default class FormSwitchBoxList extends Mixins(FormFieldMixin) {
    @Prop() readonly listOptions!: Array<ListOption>;
    @Prop() readonly value!: string;
    @Prop({ default: 'checkbox' }) readonly switchType!: string;

    get selectedOptions (): Array<string> {
      if (this.value) {
        return this.value.split(',');
      }
      return [];
    }

    public isSwitchSelected (optionValue: string): boolean {
      if (this.isMultiple) {
        return this.selectedOptions.indexOf(optionValue) !== -1;
      } else {
        return this.value === optionValue;
      }
    }

    public toggleSwitch (optionValue: string): void {
      if (this.isMultiple) {
        const currentSelectedOptions = this.selectedOptions;
        const optionIndex = currentSelectedOptions.indexOf(optionValue);
        if (optionIndex === -1) {
          currentSelectedOptions.push(optionValue);
        } else {
          currentSelectedOptions.splice(optionIndex, 1);
        }
        this.$emit('input', currentSelectedOptions.join(','));
      } else {
        this.$emit('input', optionValue);
      }
    }

    get isMultiple (): boolean {
      return this.switchType === 'checkbox';
    }
}
